import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CommonUtil } from '../../../utils/CommonUtil';
import { Constants } from '../../Languages/Constants';
import InputField from '../../../Components/InputField';
import SelectField from '../../../Components/SelectField';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { NetworkManager } from '../../../Components/NetworkManager';
import ToastManager from '../../../Components/ToastManager';

const BrokerCarrierForm = ({ mode, onClose, initialData, getDashboardCount }: any) => {
  const saasOrgId = CommonUtil.getSaasOrgId();

  useEffect(() => {
    if (mode === 'edit' && initialData) {
      formik.setValues({
        brokerCarrier: initialData.isCarrier === true ? "Carrier" : "Broker",
        name: initialData.name || '',
        phoneNumber: initialData.phoneNumber || '',
        email: initialData.email || '',
        dotNumber: initialData.dotNumber || '',
        status: initialData.status || 'Active',
      });
    }
  }, [mode, initialData]);

  
  const onLoginError = (err: any) => {
    console.log(err);
  };

  const validationSchema = Yup.object({
    brokerCarrier: Yup.string().required("Broker/Carrier is required"),
    name: Yup.string().required("Name is required"),
    phoneNumber: Yup.string()
      .matches(/^\d{11}$/, "Mobile number must be 11 digits")
      .required("Mobile number is required"),
    email: Yup.string().email("Invalid email address").nullable(),
    dotNumber: Yup.string().nullable(),
    status: Yup.string().required("Status is required"),
  });

  const formik = useFormik({
    initialValues: {
      brokerCarrier: '',
      name: '',
      phoneNumber: '',
      email: '',
      dotNumber: '',
      status: 'Active',
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmitForm(values);
    },
  });

  const onSubmitForm = (values:any) => {
    const payload = {
    dotNumber: values.dotNumber,
    email: values.email,
    isCarrier: values.brokerCarrier === "Carrier",
    name: values.name,
    phoneNumber: values.phoneNumber,
    status: values.status,
    carrierBrokerId: initialData?.carrierBrokerId,
    saasOrgId: saasOrgId,
  };

  console.log("Final Payload:", payload);
  const url = `api/v2/carrier-broker/${mode === "edit" && initialData?.carrierBrokerId ? `${initialData.carrierBrokerId}/` : ""}?saasOrgId=${saasOrgId}`;
  NetworkManager.sendJsonRequest(url, payload, "", `${mode === "edit" ? "PUT" : "POST"}`, true, onSubmitSuccess, onLoginError);
  }

  const onSubmitSuccess = (dataObj: any) =>{
    if (dataObj) {
        const restData = JSON.parse(dataObj);
        if (restData && !restData.errorMessage) {
          ToastManager.showToast(`${restData.isCarrier === true ? "Carrier" : "Broker"} Created Successfully`, "Success");
          onClose();
          getDashboardCount();
        }else{
          ToastManager.showToast(restData.errorMessage, "Error");
        }
      }
  }

  return (
    <form onSubmit={formik.handleSubmit} className='inspection-features'>
      <div className="col-md-12">
        <div className='row mb-4'>
          <div className="col-6">
          <SelectField
              name="brokerCarrier"
              placeholder="Broker/Carrier"
              onChange={formik.handleChange}
              value={formik.values.brokerCarrier}
              onBlur={formik.handleBlur}
          >
              <option value="" disabled>Select</option>
              <option value="Broker">Broker</option>
              <option value="Carrier">Carrier</option>
          </SelectField>
          {formik.touched.brokerCarrier && formik.errors.brokerCarrier && (
              <small className="ms-2 text-danger fw-700">{formik.errors.brokerCarrier}</small>
          )}
          </div>
          <div className="col-6">
          <InputField
              type="text"
              name="name"
              placeholder="Enter Name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
          />
          {formik.touched.name && formik.errors.name && (
              <small className="ms-2 text-danger fw-700">{formik.errors.name}</small>
          )}
          </div>
        </div>
        <div className='row mb-4'>
         <div className="col-6">
          <div className="d-flex cust-phone-input">
            {<div className='phone-input'> +1</div>}
          <InputField 
            type="tel"
            name="phoneNumber"
            style={{ width: "100%", borderLeft: "0px", }}
            value={formik.values.phoneNumber}
            onChange={(e:any) => formik.setFieldValue("phoneNumber", e.target.value.replace(/\D/g, ''))}
            onBlur={() => formik.setFieldTouched("phoneNumber", true)}
            placeholder="Enter Mobile Number"
          />
          </div>
          {formik.touched.phoneNumber && formik.errors.phoneNumber && (
              <small className="ms-2 text-danger fw-700">{formik.errors.phoneNumber}</small>
          )}
          </div>
          <div className="col-6">
          <InputField
              placeholder="Enter Email"
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
          />
          {formik.touched.email && formik.errors.email && (
              <small className="ms-2 text-danger fw-700">{formik.errors.email}</small>
          )}
          </div>
        </div>
        <div className='row mb-2'>
          <div className="col-6">
            <InputField
              placeholder="USDOT Number"
              type="text"
              name="dotNumber"
              maxLength={20}
              value={formik.values.dotNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-6">
            <SelectField
              name="status"
              placeholder="Select Status"
            
              onChange={formik.handleChange}
              value={formik.values.status}
              onBlur={formik.handleBlur}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </SelectField>
            {formik.touched.status && formik.errors.status && (
              <small className="ms-2 text-danger fw-700">{formik.errors.status}</small>
            )}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-outline-dark"
          data-dismiss="modal"
          onClick={() => onClose()}
        >
          {CommonUtil.getMessageText(Constants.CANCEL, "Cancel")}
        </button>
        <button type="submit" className="btn btn-success">
          {CommonUtil.getMessageText(Constants.SAVE, "Save")}
        </button>
      </div>
    </form>
  );
};

export default BrokerCarrierForm;
